import { memo } from 'react';

import { CircleXIcon, XIcon } from '@air/design-icons';
import { FileStatusButton, type FileStatusButtonProps } from '@air/feature-file-status/ui';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type TaskPaneDismissButtonProps = Omit<FileStatusButtonProps, 'appearance' | 'children' | 'color' | 'size'> & {
  label: string;
  onClick: () => void;
};

export const TaskPaneDismissButton = memo(({ label, onClick, ...rest }: TaskPaneDismissButtonProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <FileStatusButton appearance={ui2026 ? 'ghost' : 'filled'} label={label} onClick={onClick} {...rest}>
      {ui2026 ? <CircleXIcon size="sm" /> : <XIcon size="sm" />}
    </FileStatusButton>
  );
});

TaskPaneDismissButton.displayName = 'TaskPaneDismissButton';
